import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 生成visibleFilters，并同步filterData
 * @author alfielv
 */
import _ from 'lodash';
import { useMemo, useState, useEffect, useRef } from 'react';
export default (function (props) {
  var controls = props.controls,
      filterMap = props.filterMap,
      filterData = props.filterData,
      setFilterData = props.setFilterData,
      activeFilterKeys = props.activeFilterKeys,
      bizFilterKeys = props.bizFilterKeys; // 要展示的filter keys, 不在activeFilterKeys之外的keys在最后
  // 首次基于activeFilterKeys、externalKeys组合，之后只受activeFilterKeys控制

  var _useState = useState(function () {
    // 基于参数的额外展示的keys
    var externalKeys = _.difference(bizFilterKeys, activeFilterKeys);

    return [].concat(_toConsumableArray(activeFilterKeys), _toConsumableArray(externalKeys));
  }),
      _useState2 = _slicedToArray(_useState, 2),
      visibleFilterKeys = _useState2[0],
      setVisibleFilterKeys = _useState2[1]; // 所有可见的filters（包括基于自定义筛选项，以及filterData有值但尚未激活的项）


  var visibleFilters = useMemo(function () {
    // 自定义筛选项场景，基于已选项 + filterData构造
    if (_.isArray(activeFilterKeys) && !_.isEmpty(activeFilterKeys)) {
      var retFilters = _.compact(_.map(visibleFilterKeys, function (key) {
        return filterMap[key];
      }));

      return _.map(retFilters, function (filter) {
        var key = filter.key || filter.name;
        return _objectSpread(_objectSpread({}, filter), _.has(filterData, key) && {
          defaultValue: filterData[key] || filter.defaultValue
        });
      });
    } // 普通场景，直接去全量controls


    if (_.isArray(controls)) {
      return controls;
    } // 否则返回全量


    return _.compact(_.values(filterMap));
  }, [filterData, visibleFilterKeys, activeFilterKeys, controls, filterMap]); // 仅当activeFilterKeys变化时才更新visibleFilterKeys

  var activeFilterKeysRef = useRef(activeFilterKeys);
  useEffect(function () {
    if (!_.isEqual(activeFilterKeys, activeFilterKeysRef.current)) {
      // 基于最新的activeFilterKeys过滤一遍filterData
      setVisibleFilterKeys(function (prevKeys) {
        // 新增keys
        var newKeys = _.difference(activeFilterKeys, activeFilterKeysRef.current); // 删除keys


        var delKeys = _.difference(activeFilterKeysRef.current, activeFilterKeys);

        return _.uniq([].concat(_toConsumableArray(_.without.apply(_, [prevKeys].concat(_toConsumableArray(delKeys)))), _toConsumableArray(newKeys)));
      });
      activeFilterKeysRef.current = activeFilterKeys;
    }
  }, [activeFilterKeys, setVisibleFilterKeys]); // bizFilterKeys变化时重置visibleFilterKeys

  var bizFilterKeysRef = useRef(bizFilterKeys);
  useEffect(function () {
    if (!_.isEqual(bizFilterKeys, bizFilterKeysRef.current)) {
      // 基于最新的activeFilterKeys过滤一遍filterData
      setVisibleFilterKeys(function () {
        // 基于参数的额外展示的keys
        var externalKeys = _.difference(bizFilterKeys, activeFilterKeys);

        return [].concat(_toConsumableArray(activeFilterKeys), _toConsumableArray(externalKeys));
      });
      activeFilterKeysRef.current = activeFilterKeys;
    }
  }, [bizFilterKeys, activeFilterKeys, setVisibleFilterKeys]); // 自定义筛选项变更，同步更新filterData

  var visibleFilterKeysRef = useRef(visibleFilterKeys);
  useEffect(function () {
    if (!_.isEqual(visibleFilterKeys, visibleFilterKeysRef.current)) {
      setFilterData(function (prevFilterData) {
        return _.reduce(visibleFilterKeys, function (prev, curKey) {
          // 转换为[name]: value
          var name = _.get(filterMap[curKey], 'name');

          if (!_.isUndefined(prevFilterData[name])) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, prevFilterData[name]));
          }

          return prev;
        }, {});
      });
      visibleFilterKeysRef.current = visibleFilterKeys;
    }
  }, [visibleFilterKeys, filterMap, setFilterData]);
  return {
    visibleFilters: visibleFilters
  };
});